import { render, staticRenderFns } from "./HowToVote.vue?vue&type=template&id=b5b054a2"
import script from "./HowToVote.vue?vue&type=script&lang=js"
export * from "./HowToVote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports